import { ThemeConfig } from 'antd'

export const AntdThemeConfig: ThemeConfig = {
  components: {
    Checkbox: {
      colorPrimary: '#6D54FA',
      colorBorder: '#A3AABE',
      colorPrimaryHover: '#6D54FA',
    },
    Drawer: {},
    Spin: {
      colorPrimary: '#8d7afa',
    },
    DatePicker: {
      hoverBg: '#f7f9fa',
      activeBg: '#f7f9fa',
      paddingInline: 16,
      colorBgBase: '#fff',
      colorPrimary: '#6D54FA',
      controlHeight: 46,
      presetsWidth: 30,
      borderRadius: 4,
    },
    Select: {
      borderRadiusSM: 8,
      borderRadiusLG: 10,
      colorTextPlaceholder: '#999999',
      // optionSelectedColor: 'red',
      optionSelectedColor: '#6D54FA',
      optionSelectedBg: '#fff',
      optionPadding: 12,
      optionActiveBg: '#f7f9fa',
      paddingXXS: 8,
    },
    Dropdown: {
      borderRadius: 4,
      borderRadiusSM: 4,
      borderRadiusOuter: 4,
      borderRadiusXS: 4,
      borderRadiusLG: 4,
      paddingBlock: 0,
      paddingContentHorizontal: 0,
      paddingContentHorizontalLG: 0,
      paddingContentHorizontalSM: 0,
      paddingContentVerticalLG: 0,
      paddingContentVerticalSM: 0,
      paddingContentVertical: 0,
      controlPaddingHorizontal: 0,
      controlPaddingHorizontalSM: 0,
      padding: 0,
      paddingLG: 0,
      paddingMD: 0,
      paddingSM: 0,
      paddingXL: 0,
      paddingXS: 0,
      paddingXXS: 0,
    },
    Menu: {
      borderRadius: 4,
      padding: 0,
      // paddingBlock: 0,
      paddingContentHorizontal: 0,
      paddingContentVertical: 0,
      controlPaddingHorizontal: 0,
    },
    Modal: {
      borderRadiusLG: 4,
    },
    Input: {
      borderRadius: 4,
      colorBorder: '#F7F9FA',
      colorBgContainer: '#F7F9FA',
      colorTextPlaceholder: '#999999',
      controlHeight: 44,
      controlHeightLG: 48,
      paddingInline: 16,
      activeBorderColor: '#F7F9FA',
      activeShadow: '#F7F9FA',
      hoverBorderColor: '#F7F9FA',
    },
    InputNumber: {
      colorTextPlaceholder: '#999999',
    },
    Badge: {},
    Button: {
      fontWeight: 'bold',
      borderRadius: 4,
      primaryColor: '#fff',
      defaultColor: '#2a2c3f',
      defaultBg: '#fff',
      defaultBorderColor: '#2a2c3f',
      defaultHoverBg: '#fff',
      defaultHoverColor: '#1A1B28',
      defaultHoverBorderColor: '#1A1B28',
      defaultActiveBg: '#fff',
      defaultActiveColor: '#1A1B28',
      defaultActiveBorderColor: '#1A1B28',
      borderColorDisabled: '#D8D8D8',
      contentFontSizeSM: 12,
      contentFontSize: 14,
      contentFontSizeLG: 16,
      colorPrimary: '#2a2c3f',
      colorPrimaryHover: '#1A1B28',
      colorBorder: '#2a2c3f',
      colorText: '#2a2c3f',
      colorPrimaryTextHover: '#fff',
      colorLink: '#2a2c3f',
      colorLinkHover: '#1A1B28',
      controlHeightLG: 48,
      controlHeight: 36,
      controlHeightSM: 32,
      paddingInline: 24,
    },
    Pagination: {
      colorPrimary: '#2a2c3f',
      colorPrimaryHover: '#1A1B28',
    },
    Switch: {
      colorPrimary: '#6E79F7',
      colorPrimaryHover: '#6E79F7',
    },
    Cascader: {
      borderRadiusSM: 8,
      borderRadiusLG: 10,
      optionSelectedBg: '#fff',
      optionPadding: 12,
      paddingXXS: 8,
      // optionSelectedColor: '#6D54FA',
      colorPrimary: '#6D54FA',
    },
  },
}
